<template>
	<div class="vw-100 vh-100 px-0 d-flex flex-column align-items-center">
		<div class="w-100 px-0 mb-5">
			<Loading />

			<Navbar 
				:is_home="is_home"
				@search="search = $event"
				@update="articles_data = $event"
			/>
		</div>

		<transition name="fade" mode="out-in">
			<router-view 
				:articles_data="articles_data"
				:props_search="search"
			/>
		</transition>

		<Footer />
	</div>
</template>

<script>
	import Navbar from './sections/Navbar'
	import Footer from './sections/Footer'
	import Loading from './Loading'

	export default {

		name: 'Index',
		components: {
			Loading,
			Navbar,
			Footer,
		},
		data () {
			return {
				articles_data: null,
				search: '',
			}
		},
		computed: {
			is_home()
			{
				return this.$route.name == 'Home'
			}
		},
		watch: {
			search: {
				handler(val) {
					if(val == 0) {
						this.articles = []
					}
				}
			}
		},
		methods: {
		},
        beforeMount()
        {
        }
	}
</script>

<style lang="css" scoped>
</style>